import tariff from '../api/tariff';

import {
  GET_TARIFF_LIST_BEGIN,
  GET_TARIFF_LIST_SUCCESS,
  GET_TARIFF_LIST_FAILURE,
  GET_TARIFF_GROUP_LIST_BEGIN,
  GET_TARIFF_GROUP_LIST_SUCCESS,
  GET_TARIFF_GROUP_LIST_FAILURE,
  CREATE_TARIFF_GROUP_BEGIN,
  CREATE_TARIFF_GROUP_SUCCESS,
  CREATE_TARIFF_GROUP_FAILURE,
  UPDATE_TARIFF_GROUP_BEGIN,
  UPDATE_TARIFF_GROUP_SUCCESS,
  UPDATE_TARIFF_GROUP_FAILURE,
  DELETE_TARIFF_GROUP_BEGIN,
  DELETE_TARIFF_GROUP_SUCCESS,
  DELETE_TARIFF_GROUP_FAILURE,
  CREATE_TARIFF_BEGIN,
  CREATE_TARIFF_SUCCESS,
  CREATE_TARIFF_FAILURE,
  UPDATE_TARIFF_BEGIN,
  UPDATE_TARIFF_SUCCESS,
  UPDATE_TARIFF_FAILURE,
  DELETE_TARIFF_BEGIN,
  DELETE_TARIFF_SUCCESS,
  DELETE_TARIFF_FAILURE,
} from './types';

const initialState = {
  error: false,
  tariffList: {},
  tariffGroupList: {},
};

const getters = {};

const actions = {
  getTariffList({ commit }, filter) {
    commit(GET_TARIFF_LIST_BEGIN);
    return tariff.getTariffList(filter)
      .then((response) => commit(GET_TARIFF_LIST_SUCCESS, response.data))
      .catch((error) => commit(GET_TARIFF_LIST_FAILURE, error.response.data));
  },
  getTariffGroupList({ commit }, filter) {
    commit(GET_TARIFF_GROUP_LIST_BEGIN);
    return tariff.getTariffGroupList(filter)
      .then((response) => commit(GET_TARIFF_GROUP_LIST_SUCCESS, response.data))
      .catch((error) => commit(GET_TARIFF_GROUP_LIST_FAILURE, error.response.data));
  },
  createTariffGroup({ commit }, data) {
    commit(CREATE_TARIFF_GROUP_BEGIN);
    return tariff.createTariffGroup(data)
      .then((response) => commit(CREATE_TARIFF_GROUP_SUCCESS, response.data))
      .catch((error) => commit(CREATE_TARIFF_GROUP_FAILURE, error.response.data));
  },
  updateTariffGroup({ commit }, { tariffGroupId, data }) {
    commit(UPDATE_TARIFF_GROUP_BEGIN);
    return tariff.updateTariffGroup(tariffGroupId, data)
      .then((response) => commit(UPDATE_TARIFF_GROUP_SUCCESS, response.data))
      .catch((error) => commit(UPDATE_TARIFF_GROUP_FAILURE, error.response.data));
  },
  deleteTariffGroup({ commit }, id) {
    commit(DELETE_TARIFF_GROUP_BEGIN);
    return tariff.deleteTariffGroup(id)
      .then((response) => commit(DELETE_TARIFF_GROUP_SUCCESS, response.data))
      .catch((error) => commit(DELETE_TARIFF_GROUP_FAILURE, error.response.data));
  },
  createTariff({ commit }, data) {
    commit(CREATE_TARIFF_BEGIN);
    return tariff.createTariff(data)
      .then((response) => commit(CREATE_TARIFF_SUCCESS, response.data))
      .catch((error) => commit(CREATE_TARIFF_FAILURE, error.response.data));
  },
  updateTariff({ commit }, { tariffId, data }) {
    commit(UPDATE_TARIFF_BEGIN);
    return tariff.updateTariff(tariffId, data)
      .then((response) => commit(UPDATE_TARIFF_SUCCESS, response.data))
      .catch((error) => commit(UPDATE_TARIFF_FAILURE, error.response.data));
  },
  deleteTariff({ commit }, id) {
    commit(DELETE_TARIFF_BEGIN);
    return tariff.deleteTariff(id)
      .then((response) => commit(DELETE_TARIFF_SUCCESS, response.data))
      .catch((error) => commit(DELETE_TARIFF_FAILURE, error.response.data));
  },
};

const mutations = {
  [GET_TARIFF_LIST_BEGIN](state) {
    state.error = false;
  },
  [GET_TARIFF_LIST_SUCCESS](state, data) {
    state.tariffList = data;
    state.error = false;
  },
  [GET_TARIFF_LIST_FAILURE](state, data) {
    state.error = data;
  },
  [GET_TARIFF_GROUP_LIST_BEGIN](state) {
    state.error = false;
  },
  [GET_TARIFF_GROUP_LIST_SUCCESS](state, data) {
    state.tariffGroupList = data;
    state.error = false;
  },
  [GET_TARIFF_GROUP_LIST_FAILURE](state, data) {
    state.error = data;
  },
  [CREATE_TARIFF_GROUP_BEGIN](state) {
    state.error = false;
  },
  [CREATE_TARIFF_GROUP_SUCCESS](state) {
    state.error = false;
  },
  [CREATE_TARIFF_GROUP_FAILURE](state, data) {
    state.error = data;
  },
  [UPDATE_TARIFF_GROUP_BEGIN](state) {
    state.error = false;
  },
  [UPDATE_TARIFF_GROUP_SUCCESS](state) {
    state.error = false;
  },
  [UPDATE_TARIFF_GROUP_FAILURE](state, data) {
    state.error = data;
  },
  [DELETE_TARIFF_GROUP_BEGIN](state) {
    state.error = false;
  },
  [DELETE_TARIFF_GROUP_SUCCESS](state) {
    state.error = false;
  },
  [DELETE_TARIFF_GROUP_FAILURE](state, data) {
    state.error = true;
    state.errorText = data;
  },
  [CREATE_TARIFF_BEGIN](state) {
    state.error = false;
  },
  [CREATE_TARIFF_SUCCESS](state) {
    state.error = false;
  },
  [CREATE_TARIFF_FAILURE](state, data) {
    state.error = data;
  },
  [UPDATE_TARIFF_BEGIN](state) {
    state.error = false;
  },
  [UPDATE_TARIFF_SUCCESS](state) {
    state.error = false;
  },
  [UPDATE_TARIFF_FAILURE](state, data) {
    state.error = data;
  },
  [DELETE_TARIFF_BEGIN](state) {
    state.error = false;
  },
  [DELETE_TARIFF_SUCCESS](state) {
    state.error = false;
  },
  [DELETE_TARIFF_FAILURE](state, data) {
    state.error = true;
    state.errorText = data;
  },

};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
